function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-notifications-none",
  "data-name": "Icon material-notifications-none",
  d: "M13.88,22.957a1.976,1.976,0,0,0,1.97-1.97H11.91A1.976,1.976,0,0,0,13.88,22.957Zm5.91-5.91V12.122c0-3.024-1.606-5.555-4.432-6.225v-.67a1.477,1.477,0,0,0-2.955,0V5.9c-2.817.67-4.432,3.191-4.432,6.225v4.925L6,19.017V20H21.76v-.985Zm-1.97.985H9.94v-5.91c0-2.443,1.487-4.432,3.94-4.432s3.94,1.99,3.94,4.432Z",
  transform: "translate(-6 -3.75)",
  opacity: 0.5
});

var SvgNotifications = function SvgNotifications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.76,
    height: 19.207,
    viewBox: "0 0 15.76 19.207",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotifications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifications.ee50bd92.svg";
export { ForwardRef as ReactComponent };